import { render, staticRenderFns } from "./AddPopup.vue?vue&type=template&id=5c9a4e88&scoped=true&"
import script from "./AddPopup.vue?vue&type=script&lang=js&"
export * from "./AddPopup.vue?vue&type=script&lang=js&"
import style0 from "./AddPopup.vue?vue&type=style&index=0&id=5c9a4e88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9a4e88",
  null
  
)

export default component.exports